import userAddedToTeamEmailTemplate from './user-added-to-team-email-template';

export { default as userAddedToTeamEmailTemplate } from './user-added-to-team-email-template';

export default {
  userAddedToTeamEmailTemplate,
};
